export default "__VITE_ASSET__HDvDWLP0__"